import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { nullSafe } from 'Utility/globalMethods'
import * as ResultsActions from '../../modules/ResultsActions'
import ForeignCardDetail from './ForeignCardDetail'
import { doHidePopup } from 'Store/actions/popup'

const mapDispatchToProps = (dispatch) => ({
  ...bindActionCreators(ResultsActions, dispatch),
  doClosePopup: (type) => dispatch(doHidePopup(type))
})

const mapStateToProps = (state) => ({
  tabSelected: nullSafe(() => state.Results.tabSelected, 'ONE_PERIOD'),
  groupByCountry: nullSafe(() => state.Results.groupByCountry, {}),
  referredPeriod: nullSafe(() => state.Results.referredPeriod, [])
})

export default connect(mapStateToProps, mapDispatchToProps, (stateProps, dispatchProps, mergeProps) => ({
  ...stateProps,
  ...mergeProps,
  actions: dispatchProps
}))(ForeignCardDetail)
